import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Logout({ config }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    axios.post(config.backend_api + 'logout.php')
      .then(() => {
        logout();
        navigate('/login', { replace: true });
      })
      .catch((error) => {
        console.error(error);
        logout();
        navigate('/login', { replace: true });
      });
  }, [config, navigate, logout]);

  return null;
}

export default Logout;